<template>
  <div>
    <ClientConclusionDiagnosisForm
        v-if="showForm"
        :establishment="establishment"
        :diagnoses="diagnoses"
        :types="types"
        v-on:submit="submitForm"
        v-on:delete="deleteItem"
        v-on:cancel="closeForm"/>

    <div class="mb-5">
      <div
          v-if="unspecified.length > 0"
          class="py-3 px-4 border bg-light font-weight-bold text-secondary position-relative">
        Предварительные диагнозы
      </div>

      <ClientConclusionDiagnosisList
          v-if="unspecified.length > 0"
          v-on:select="selectEstablishment"
          :items="unspecified" />

      <div class="py-3 px-4 border bg-light font-weight-bold text-secondary position-relative">
        Диагнозы

        <div class="position-absolute"  style="right:10px;top:8px;">
          <button
            class="btn btn-primary"
            @click="showForm = true">
            Новый диагноз
          </button>
        </div>
      </div>

      <ClientConclusionDiagnosisList
          v-on:select="selectEstablishment"
          :items="current" />

      <div
          @click="showPast =! showPast"
          class="py-3 px-4 border-left border-right border-bottom bg-light font-weight-bold text-secondary pointer">
        <u>История диагнозов</u>
      </div>

      <ClientConclusionDiagnosisList
          v-on:select="selectEstablishment"
          v-if="showPast"
          :items="past" />
    </div>
  </div>
</template>

<script>
import ClientConclusionDiagnosisList from './diagnosis/List';
import ClientConclusionDiagnosisForm from './diagnosis/Form';
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientConclusionDiagnoses',

  components: {ClientConclusionDiagnosisList, ClientConclusionDiagnosisForm},

  props: ['diagnoses', 'establishments', 'submitDiagnosisEstablishment', 'deleteDiagnosisEstablishment'],

  data() {
    return {
      showPast: false,
      establishmentId: null,
      showForm: false,
      types: {
        basic: 'основной диагноз',
        complication: 'осложнения основного',
        concomitant: 'сопутствующий',
        unspecified: 'предварительный диагноз',
      },
    };
  },

  computed: {
    data() {
      const data = this.establishments.map(e => {
        const {id, note, createdBy, type} = e;
        const dateFrom = new Date(e.dateFrom);
        const dateTo = typeof e.dateTo === 'string' && e.dateTo.trim() !== '' ? new Date(e.dateTo) : '';
        const diagnosis = this.diagnoses.find(f => f.id === e.diagnosis);
        const typeTitle = typeof this.types[type] !== 'undefined' ? this.types[type] : '-';

        return { id, dateFrom, dateTo, note, diagnosis, createdBy, type, typeTitle };
      });

      data.sort((a, b) => b.dateFrom.getTime() - a.dateFrom.getTime());

      return data;
    },

    past() {
      return this.data.filter(i => i.dateTo instanceof Date);
    },

    unspecified() {
      return this.data.filter(i => (!(i.dateTo instanceof Date) && i.type === 'unspecified'));
    },

    current() {
      return this.data.filter(i => (!(i.dateTo instanceof Date) && i.type !== 'unspecified'));
    },

    establishment() {
      return this.establishments.find(i => i.id === this.establishmentId);
    },
  },

  methods: {
    selectEstablishment(id) {
      this.showForm = true;
      this.establishmentId = id;
    },

    closeForm() {
      this.showForm = false;
      this.establishmentId = null;
    },

    formatDate(date, format) {
      return formatDate(date, format);
    },

    async submitForm(data) {
      await this.submitDiagnosisEstablishment(data);

      this.closeForm();
    },

    async deleteItem(id) {
      await this.deleteDiagnosisEstablishment(id);

      this.closeForm();
    },
  },
};
</script>
